import React from "react";

function getEmployeeName(emp) {
  return emp?.name || emp?.displayName || emp?.email || "Unknown";
}

function getEmployeePosition(emp) {
  return emp?.position || emp?.title || emp?.role || emp?.basePosition || emp?.providerLevel || "";
}

export default function AssignmentChip({
  assignment,
  employee,
  onOpen,
  onDragStart,
  onDragEnd,
  onDrop,
  onDragOver,
  draggable = true,
}) {
  const pos = getEmployeePosition(employee);

  return (
    <div
      role="button"
      tabIndex={0}
      draggable={draggable}
      className="sched-chip"
      title={`${getEmployeeName(employee)} • ${assignment.start}-${assignment.end}`}
      onClick={onOpen}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onOpen?.();
        }
      }}
      onDragStart={(e) => onDragStart(e, assignment)}
      onDragEnd={onDragEnd}
      onDragOver={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onDragOver?.(e);
      }}
      onDrop={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onDrop?.(e);
      }}
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 6,
        width: "100%",
        padding: "6px 8px",
        borderRadius: 8,
        border: "1px solid #cbd5e1",
        background: "#f8fafc",
        cursor: "pointer",
        color: "#0f172a",
        opacity: 1,
        textAlign: "left",
      }}
    >
      <div style={{ textAlign: "left", minWidth: 0, flex: 1 }}>
        <div
          style={{
            fontWeight: 800,
            fontSize: 11,
            color: "#0f172a",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {getEmployeeName(employee)}
        </div>
        <div
          style={{
            fontSize: 9,
            color: "#475569",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {assignment.start} - {assignment.end}
          {pos ? ` • ${pos}` : ""}
        </div>
      </div>

      <div
        style={{
          fontSize: 9,
          color: "#64748b",
          fontWeight: 800,
          flexShrink: 0,
          pointerEvents: "none",
        }}
      >
        ↕
      </div>
    </div>
  );
}